export default __webpack_public_path__ + "static/media/section_image.a33dc292.svg";